import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Teleport as _Teleport, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4bfe2103")
const _hoisted_1 = { class: "header mb-[12px] flex w-full items-center justify-between" }
const _hoisted_2 = { class: "title ml-[18px] mt-[10px]" }
const _hoisted_3 = { class: "dark-back" }
const _hoisted_4 = { class: "px-[12px] pb-[12px] " }
const _hoisted_5 = {
  key: 1,
  disabled: true,
  class: "amount-button font-semibold"
}
const _hoisted_6 = {
  key: 2,
  class: "stats"
}
const _hoisted_7 = { class: "p-[12px]" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mx-[8px] my-[22px] border" })
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TradeSettingsPopover = _resolveComponent("TradeSettingsPopover")!
  const _component_TradePair = _resolveComponent("TradePair")!
  const _component_BalAlert = _resolveComponent("BalAlert")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_TradePreviewModalGP = _resolveComponent("TradePreviewModalGP")!
  const _component_TradeRoute = _resolveComponent("TradeRoute")!
  const _component_BalCard = _resolveComponent("BalCard")!
  const _component_ConfirmSwapModal = _resolveComponent("ConfirmSwapModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BalCard, {
      noPad: "",
      noBorder: "",
      class: "card-container relative",
      shadow: _ctx.tradeCardShadow
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.title), 1),
          _createVNode(_component_TradeSettingsPopover, {
            context: _ctx.TradeSettingsContext.trade,
            isGasless: _ctx.trading.tradeGasless.value
          }, null, 8, ["context", "isGasless"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_TradePair, {
            tokenInAmount: _ctx.tokenInAmount,
            "onUpdate:tokenInAmount": _cache[0] || (_cache[0] = ($event: any) => (_ctx.tokenInAmount = $event)),
            tokenInAddress: _ctx.tokenInAddress,
            "onUpdate:tokenInAddress": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tokenInAddress = $event)),
            tokenOutAmount: _ctx.tokenOutAmount,
            "onUpdate:tokenOutAmount": _cache[2] || (_cache[2] = ($event: any) => (_ctx.tokenOutAmount = $event)),
            tokenOutAddress: _ctx.tokenOutAddress,
            "onUpdate:tokenOutAddress": _cache[3] || (_cache[3] = ($event: any) => (_ctx.tokenOutAddress = $event)),
            exactIn: _ctx.exactIn,
            "onUpdate:exactIn": _cache[4] || (_cache[4] = ($event: any) => (_ctx.exactIn = $event)),
            tradeLoading: 
          _ctx.trading.isBalancerTrade.value ? _ctx.trading.isLoading.value : false
        ,
            effectivePriceMessage: _ctx.trading.effectivePriceMessage,
            class: "mb-[12px]",
            onAmountChange: _ctx.trading.handleAmountChange
          }, null, 8, ["tokenInAmount", "tokenInAddress", "tokenOutAmount", "tokenOutAddress", "exactIn", "tradeLoading", "effectivePriceMessage", "onAmountChange"]),
          (_ctx.error)
            ? (_openBlock(), _createBlock(_component_BalAlert, {
                key: 0,
                class: "mb-[12px]",
                type: "error",
                size: "sm",
                title: _ctx.error.header,
                description: _ctx.error.body,
                actionLabel: _ctx.error.label,
                block: "",
                onActionClick: _ctx.handleErrorButtonClick
              }, null, 8, ["title", "description", "actionLabel", "onActionClick"]))
            : (_ctx.warning)
              ? (_openBlock(), _createBlock(_component_BalAlert, {
                  key: 1,
                  class: "mb-[12px]",
                  type: "warning",
                  size: "sm",
                  title: _ctx.warning.header,
                  description: _ctx.warning.body,
                  block: ""
                }, null, 8, ["title", "description"]))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.trading.isLoading.value)
              ? (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 0,
                  loading: "",
                  disabled: "",
                  loadingLabel: 
          _ctx.trading.isGnosisTrade.value ? _ctx.$t('loadingBestPrice') : _ctx.$t('loading')
        ,
                  class: "font-semibold",
                  block: ""
                }, null, 8, ["loadingLabel"]))
              : (_ctx.tokenInAmount == 0 && _ctx.tokenOutAmount == 0 && _ctx.account)
                ? (_openBlock(), _createElementBlock("button", _hoisted_5, " Enter an amount "))
                : (_ctx.account)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      disabled: false,
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handlePreviewButton && _ctx.handlePreviewButton(...args))),
                      class: "swap-button text-[16px] font-semibold"
                    }, " Swap "))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "connect-wallet font-semibold",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.startConnectWithInjectedProvider && _ctx.startConnectWithInjectedProvider(...args)))
                    }, " Connect Wallet "))
          ]),
          (
          _ctx.tokenInAddress &&
          _ctx.tokenOutAddress &&
          _ctx.tokenInAmount > 0 &&
          _ctx.tokenOutAmount > 0
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_TradePreviewModalGP, {
                    trading: _ctx.trading,
                    onTrade: _ctx.trade,
                    onClose: _ctx.handlePreviewModalClose
                  }, null, 8, ["trading", "onTrade", "onClose"]),
                  _hoisted_8,
                  _hoisted_9,
                  _createVNode(_component_TradeRoute, {
                    addressIn: _ctx.trading.tokenIn.value.address,
                    amountIn: _ctx.trading.tokenInAmountInput.value,
                    addressOut: _ctx.trading.tokenOut.value.address,
                    amountOut: _ctx.trading.tokenOutAmountInput.value,
                    pools: _ctx.trading.sor.pools.value,
                    sorReturn: _ctx.trading.sor.sorReturn.value,
                    class: ""
                  }, null, 8, ["addressIn", "amountIn", "addressOut", "amountOut", "pools", "sorReturn"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["shadow"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      (_ctx.modalTradePreviewIsOpen)
        ? (_openBlock(), _createBlock(_component_ConfirmSwapModal, {
            key: 0,
            trading: _ctx.trading,
            onTrade: _ctx.trade,
            onClose: _ctx.handlePreviewModalClose
          }, null, 8, ["trading", "onTrade", "onClose"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}